// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BusComponent from '../../BusComponent';

import ClassesItemImage from '../ClassesItemImage';
import ClassesItemLabel from '../ClassesItemLabel';

/**
 * @typedef Props
 * @property {import('../../../').LayerLibraryItemMetadataClass} item
 * @property {boolean} interactive
 * @property {boolean} layerVisibility
 * @property {function} toggleLayerVisibility
 *
 * @extends BusComponent<Props>
 */
class LayerLibraryLegendItem extends BusComponent {
    onToggle = () => {
        const { item, interactive, toggleLayerVisibility } = this.props;

        if (!interactive) return;

        toggleLayerVisibility({
            id: item['layer-group-id'],
        });
    };

    render() {
        const { item, layerVisibility, interactive } = this.props;
        const { type, style, label, svg, iconSize, isLabelHtml } = item;
        const containerClasses = classNames('layer-library-legend__item', {
            'layer-library-legend__item--disabled': !layerVisibility,
            'layer-library-legend__item--interactive': interactive,
        });

        const itemImage = item.isUserLayer ? (
            <ClassesItemImage
                svg={svg}
                type={item.icon}
                style={style}
                markerStyle={item.markerStyle}
            />
        ) : (
            <ClassesItemImage svg={svg} type={type} style={style} iconSize={iconSize} />
        );

        return (
            <div className={containerClasses} onClick={this.onToggle}>
                {itemImage}
                <ClassesItemLabel isLabelHtml={isLabelHtml} label={label} />
            </div>
        );
    }
}

LayerLibraryLegendItem.propTypes = {
    item: PropTypes.object.isRequired,
    layerVisibility: PropTypes.bool.isRequired,
    interactive: PropTypes.bool.isRequired,
    toggleLayerVisibility: PropTypes.func.isRequired,
};

export default LayerLibraryLegendItem;
